export default __webpack_public_path__ + "static/media/manejebem-embrapa-logo.73f1d776.svg";